'use strict';

import jQuery from 'jquery';
import Core from './../Core/Core';

jQuery(document).ready(function($) {
    // Social (Facebook, Twitter and Email)
    $('.socials').on('click', '.social-share',
        Core.utils.onSocialShare
    );
});

export default {}